"use client";

import React, { useState } from "react";
import "../../styles/signup.css";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../../firebase/firebase";
import {
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import axios from "axios";
import Constant from "../../helper/Constant";
import { FcGoogle } from "react-icons/fc";

export default function AuthPage() {
  const navigate = useNavigate();

  const [mode, setMode] = useState("login");
  const [loading, setLoading] = useState(false);
  const [loadingGoogle, setGoogleLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile: "",
    password: "",
  });
  const [isChecked, setIsChecked] = useState(false);
  const [showError, setShowError] = useState(false);

  const completeAuthentication = (response, fallbackMessage) => {
    if (response?.data?.token) {
      localStorage.setItem("token", response.data.token);
    }

    if (response?.data?.user) {
      localStorage.setItem("user", JSON.stringify(response.data.user));
    }

    alert(response?.data?.message || fallbackMessage);

    const redirectPath = localStorage.getItem("redirectAfterLogin");

    if (redirectPath) {
      localStorage.removeItem("redirectAfterLogin");
      window.location.href = redirectPath;
    } else {
      window.location.href = "/";
    }
  };

  /* Handle input */
  const handleChange = (field, value) => {
    if (field === "mobile") {
      const cleaned = value.replace(/\D/g, "");

      if (cleaned.length <= 10) {
        setForm({
          ...form,
          mobile: cleaned,
        });
      }
      return;
    }

    setForm({
      ...form,
      [field]: value,
    });
  };

  /* REGISTER */
  const registerWithPassword = async () => {
    if (!form.name.trim()) {
      alert("Enter full name");
      return;
    }

    if (!form.email.trim()) {
      alert("Enter email");
      return;
    }

    if (form.mobile.length !== 10) {
      alert("Enter valid mobile number");
      return;
    }

    if (!form.password) {
      alert("Enter password");
      return;
    }

    if (form.password.length < 6) {
      alert("Password must be at least 6 characters");
      return;
    }

    if (!isChecked) {
      setShowError(true);
      return;
    }

    try {
      setLoading(true);

      const payload = {
        name: form.name,
        email: form.email,
        password: form.password,
        mobile_no: form.mobile,
      };

      await axios.post(Constant.postUrls.register, payload);

      alert("Registered successfully. Please login with your mobile number and password.");
      setMode("login");
      setIsChecked(false);
      setShowError(false);
      setForm((prev) => ({
        ...prev,
        name: "",
        email: "",
        password: "",
      }));
    } catch (error) {
      alert(
        error?.response?.data?.message ||
          error.message ||
          "Registration failed"
      );
    } finally {
      setLoading(false);
    }
  };

  /* PASSWORD LOGIN */
  const loginWithPassword = async () => {
    if (form.mobile.length !== 10) {
      alert("Enter valid mobile number");
      return;
    }

    if (!form.password) {
      alert("Enter password");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        mobile_no: form.mobile,
        password: form.password,
      };

      const response = await axios.post(Constant.postUrls.login, payload);
      completeAuthentication(response, "Login successful");
    } catch (error) {
      alert(
        error?.response?.data?.message ||
          error.message ||
          "Login failed"
      );
    } finally {
      setLoading(false);
    }
  };

  /* GOOGLE LOGIN */
  const handleGoogleLogin = async () => {
    try {
      setGoogleLoading(true);

      const provider = new GoogleAuthProvider();

      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      // console.log(user);
      
      const payload = {
        name: user.displayName,
        email: user.email,
        firebase_uid: user.uid,
      };

      console.log("PAYLOAD:", payload);
      console.log("API URL:", Constant.postUrls.googleAuth);

      const response = await axios.post(
        Constant.postUrls.googleAuth,
        payload
      );

      console.log("GOOGLE RESPONSE:", response);

      /* SAVE TOKEN */
      if (response?.data?.token) {
        localStorage.setItem("token", response.data.token);
      }

      /* SAVE USER */
      if (response?.data?.user) {
        localStorage.setItem("user", JSON.stringify(response.data.user));
      }

      localStorage.setItem("firebase_uid", user.uid);

      alert(response?.data?.message || "Google login successful");

      navigate("/", { replace: true });
      window.location.href = "/";

    } catch (error) {
      console.log("FULL ERROR:", error);
      console.log("DATA:", error?.response?.data);

      alert(
        error?.response?.data?.message ||
        error.message ||
        "Google login failed"
      );
    } finally {
      setGoogleLoading(false);
    }
  };

  const handleChangeTerm = (e) => {
    setIsChecked(e.target.checked);
  };

  return (
    <div className="auth-page">
      <div className="auth-container">

        {/* Tabs */}
        <div className="auth-tabs">
          <button
            className={mode === "login" ? "active" : ""}
            onClick={() => {
              setMode("login");
              setShowError(false);
            }}
          >
            Login
          </button>

          <button
            className={mode === "signup" ? "active" : ""}
            onClick={() => {
              setMode("signup");
              setShowError(false);
            }}
          >
            Register
          </button>
        </div>

        {/* FORM */}
        <div className="auth-form">
            {mode === "signup" && (
              <input
                placeholder="Full Name"
                value={form.name}
                onChange={(e) => handleChange("name", e.target.value)}
              />
            )}

            {mode === "signup" && (
              <input
                placeholder="Email"
                value={form.email}
                onChange={(e) => handleChange("email", e.target.value)}
              />
            )}

            <input
              placeholder="Mobile Number"
              value={form.mobile}
              onChange={(e) => handleChange("mobile", e.target.value)}
            />

            {(mode === "signup" || mode === "login") && (
              <>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={form.password}
                  onChange={(e) => handleChange("password", e.target.value)}
                />
                <label className="auth-show-password">
                  <input
                    type="checkbox"
                    checked={showPassword}
                    onChange={(e) => setShowPassword(e.target.checked)}
                  />
                  <span>{showPassword ? "Hide password" : "Show password"}</span>
                </label>
              </>
            )}

            {mode === "signup" && (
              <div className="auth-chk">
                <label>
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleChangeTerm}
                  />
                  <div className="auth-chkterms">
                    <Link to="/terms-and-conditions">Terms and Condition</Link>
                  </div>
                  {showError && !isChecked && (
                    <p className="termsErrMsg">
                      Please accept Terms and Conditions
                    </p>
                  )}
                </label>
              </div>
            )}

            <button
              className="auth-submit"
              onClick={
                mode === "login" ? loginWithPassword : registerWithPassword
              }
              disabled={loading}
            >
              {loading
                ? mode === "login"
                  ? "Logging in..."
                  : "Registering..."
                : mode === "login"
                ? "Login"
                : "Register"}
            </button>

            <div className="auth-divider">
              <span>OR</span>
            </div>

            {/* GOOGLE LOGIN BUTTON */}
            <button
              className="google-btn"
              onClick={handleGoogleLogin}
              disabled={loadingGoogle}
            >
              <FcGoogle size={20} style={{ marginRight: "8px" }} />
              {loadingGoogle ? "Processing..." : "Continue with Google"}
            </button>
        </div>

        {/* Footer */}
        <div className="auth-footer">
          {mode === "login" ? (
            <>
              Don't have an account?
              <span
                onClick={() => {
                  setMode("signup");
                  setShowError(false);
                }}
              >
                Register
              </span>
            </>
          ) : (
            <>
              Already have an account?
              <span
                onClick={() => {
                  setMode("login");
                  setShowError(false);
                }}
              >
                Login
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
